module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/pc/hospital_detail/icon_stethscope-be11ad85b1f9a543919b778a02c2489f.svg";